import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/land-clearing-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/land-clearing",
      statusCode: 301,
    });
  },
});
